"use client";

import React from "react";
import { Stethoscope } from "lucide-react";

export function AuthLayout({
  children,
  title,
  subtitle,
}) {
  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-[#eae3d8]">
      {/* Mobile view */}
      <div className="md:hidden min-h-screen flex flex-col">
        <div className="h-[220px] bg-[#13263d] flex flex-col items-center justify-center text-white px-6">
          <h1 className="text-4xl font-semibold">VirtualScribe</h1>
          <p className="text-sm text-gray-300 mt-2 text-center">
            AI Powered Medical Documentation
          </p>
        </div>

        <div className="-mt-8 px-4 pb-8 relative z-10">
          <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8 max-w-lg mx-auto">
            <div className="text-center mb-6">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h2>
              <p className="text-gray-500 text-base mt-1.5">{subtitle}</p>
            </div>
            {children}
          </div>
        </div>
      </div>

      {/* Desktop view */}
      <div className="hidden md:flex min-h-screen w-full">
        {/* Left panel */}
        <div className="w-1/2 bg-[#1f3446] relative text-white px-12 lg:px-16 py-10 flex flex-col">
          {/* Background design */}
          <div className="absolute inset-0 opacity-5 pointer-events-none">
            <div className="absolute top-16 left-16 text-[180px] font-bold leading-none">
              +
            </div>

            <div className="absolute bottom-16 right-16 text-[180px] font-bold leading-none">
              +
            </div>

            <div className="absolute top-1/2 left-1/3 text-[160px] font-bold leading-none">
              +
            </div>
          </div>

          {/* Center content */}
          <div className="relative z-10 flex flex-col justify-center h-full">
            <div className="flex items-center gap-3 mb-8">
              <Stethoscope className="w-8 h-8 lg:w-10 lg:h-10" />
              <h1 className="text-4xl lg:text-5xl font-semibold">
                VirtualScribe
              </h1>
            </div>

            <p className="text-lg lg:text-xl text-gray-300 mb-8">
              AI Powered Medical Documentation
            </p>

            <div className="flex gap-3 flex-wrap">
              <span className="px-4 py-2 bg-white/10 rounded-full text-sm">
                SOAP Notes
              </span>
              <span className="px-4 py-2 bg-white/10 rounded-full text-sm">
                ICD-10 Coding
              </span>
              <span className="px-4 py-2 bg-white/10 rounded-full text-sm">
                Smart Templates
              </span>
            </div>
          </div>
        </div>

        {/* Right panel */}
        <div className="w-1/2 bg-[#eae3d8] flex items-center justify-center px-6 lg:px-10 py-8">
          <div className="bg-white w-full max-w-[490px] lg:max-w-[520px] rounded-2xl shadow-xl p-8 sm:p-10">
            <div className="text-center mb-7">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">{title}</h2>
              <p className="text-gray-500 text-base sm:text-lg mt-1.5">{subtitle}</p>
            </div>

            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
